import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance1qq3nwu3zphmj as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      s3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      h6t(writer, customScalarAdapters, value) {
        writer.n4a('partyId');
        get_partyIdAdapter().t3x(writer, customScalarAdapters, value.v6r_1);
        writer.n4a('playerId');
        get_playerIdAdapter().t3x(writer, customScalarAdapters, value.w6r_1);
        writer.n4a('name');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.x6r_1);
        writer.n4a('email');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.y6r_1);
        writer.n4a('badge');
        Badge_ResponseAdapter_instance.l6l(writer, customScalarAdapters, value.z6r_1);
        writer.n4a('callSignAdjective');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.a6s_1);
        writer.n4a('callSignNoun');
        get_StringAdapter().t3x(writer, customScalarAdapters, value.b6s_1);
        var tmp = value.c6s_1;
        if (tmp instanceof Present()) {
          writer.n4a('imageURL');
          present(get_NullableStringAdapter()).r3y(writer, customScalarAdapters, value.c6s_1);
        }
        var tmp_0 = value.d6s_1;
        if (tmp_0 instanceof Present()) {
          writer.n4a('avatarType');
          present(get_NullableStringAdapter()).r3y(writer, customScalarAdapters, value.d6s_1);
        }
        writer.n4a('unvalidatedEmails');
        list(get_StringAdapter()).p3y(writer, customScalarAdapters, value.e6s_1);
      }
      t3x(writer, customScalarAdapters, value) {
        return this.h6t(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instance1je9qlh2ltjfd,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
